export default __webpack_public_path__ + "static/media/54.1bc01c41.jpg";